import type { PlanSizeTier } from '@prerender/diagnostics-api';

export const PLAN_SIZE_TIER_LABELS: Record<PlanSizeTier, string> = {
  starter: 'Starter',
  growth: 'Growth',
  pro: 'Pro',
  enterprise: 'Enterprise',
};

export function planSizeTierLabel(tier: PlanSizeTier): string {
  return PLAN_SIZE_TIER_LABELS[tier];
}
